import './styles/Spinner.scss';

function Spinner(props) {
    const {
        fullScreen = false,
    }  = props;

    return (
        <div className={fullScreen ? 'loaderContainer' : ''}>
            <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export default Spinner;
